export const theme = {
    colors: {
        accent: '#7B61FF',
        red: '#FF2B77',
        yellow: '#E2A300',
        green: '#6BD475',
        primaryText: '#ACA7C3',
        secondaryText: '#3F3F3F',
        textColor: '#49454F',
        titleColor: '#1C1B1F',
        white: '#FFFFFF',
        hover: '#9747FF',
    },

    fontSizes: {
        textSize: '14px',
        subtitleSize: '16px',
        titleSize: '24px',
        maxSize: '32px',
    },

    fontWaight: {
        regular: 400,
        medium: 500,
        semibold: 600,
    },

    screens: {
        mobWidth: '320px',
        tabWidth: '768px',
        deskWidth: '1280px',
    }
}